
import {defineComponent} from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {CustomerContext} from "@/context/CustomerContext";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import {PaymentProviderWebhookInfoRestDto} from "@/api/pharma-pay-payment/models";
import {PaymentProviderRestService} from "@/services/rest/pay-payment/PaymentProviderRestService";

export default defineComponent({
  name: "Bpost",
  components: {
    BaseTitle, BaseContainer
  },
  data() {
    return {
      webhookInfo: null as PaymentProviderWebhookInfoRestDto|null,
    }
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
  },
  mounted() {
    this.reloadContent();
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.webhookInfo = await PaymentProviderRestService.getInstance()
        .getPaymentProviderWebhookInfo(
          CustomerContext.getPharmacyCode(),
          'WORLDLINE',
        );
    }
  }
});
